import { render } from "./infoicon.vue?vue&type=template&id=6a62f3f8"
import script from "./infoicon.vue?vue&type=script&lang=js"
export * from "./infoicon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__